// Polyfills for built-ins that babel-preset-react-app transpiles syntax for but never shims.
// MUI's DataGrid virtualiser calls Array.prototype.at(-1), which is ES2022: browsers older
// than Chrome/Edge 92, Firefox 90 or Safari 15.4 throw "dataRowIds.at is not a function"
// and every grid in the app fails to render.

function at(index) {
	const len = this.length;
	let i = Math.trunc(index) || 0;
	if (i < 0) i += len;
	if (i < 0 || i >= len) return undefined;
	return this[i];
}

if (!Array.prototype.at)
	Object.defineProperty(Array.prototype, 'at', { value: at, writable: true, configurable: true });

if (!String.prototype.at)
	Object.defineProperty(String.prototype, 'at', { value: at, writable: true, configurable: true });

// color-string (pulled in by @react-pdf) calls Object.hasOwn at module scope, so the whole
// PDF chunk fails to evaluate on Chrome < 93 rather than failing at the point of use.
if (!Object.hasOwn)
	Object.defineProperty(Object, 'hasOwn', {
		value: function (obj, prop) {
			if (obj === null || obj === undefined) throw new TypeError('Cannot convert undefined or null to object');
			return Object.prototype.hasOwnProperty.call(Object(obj), prop);
		},
		writable: true,
		configurable: true
	});
